module.exports = __webpack_public_path__ + "static/media/21ECLAC13.040a982e.jpg";